// Texted sign-in codes. Amplify can't "send the code again": signing in again with the
// same email and password is what makes Cognito text a fresh code (and opens a new
// challenge session). signIn is passed in (from aws-amplify/auth) to keep this module
// free of Amplify imports, like signInSessionRetry.js.
export const SMS_STEP = 'CONFIRM_SIGN_IN_WITH_SMS_CODE';

export function smsDestination(nextStep) {
  return nextStep?.codeDeliveryDetails?.destination || '';
}

/**
 * Restart sign-in so Cognito texts a fresh code. Resolves to the masked destination.
 * Rejects when there's nothing to restart with, or Cognito doesn't land on the texted
 * code again — the caller then sends the person back to sign in.
 */
export async function restartSmsChallenge({ credentials, signIn }) {
  if (!credentials) throw new Error('No sign-in to restart');
  const { isSignedIn, nextStep } = await signIn(credentials);
  if (isSignedIn || nextStep?.signInStep !== SMS_STEP) {
    throw new Error(`Expected a texted code, got ${isSignedIn ? 'DONE' : nextStep?.signInStep}`);
  }
  return smsDestination(nextStep);
}
